
import {defineComponent} from 'vue';

export default defineComponent({
    data() {
        return {
            isExpanded: false,
        }
    },
    watch: {
        isExpanded() {
            document.body.classList.toggle('live-ticker-expanded', this.isExpanded);
        }
    },
    methods: {
        expand() {
            this.isExpanded = true;
        },
        collapse() {
            this.isExpanded = false;
        }
    }
})
